import * as React from 'react';
import DetailsContainer from '../../components/tables/DetailsContainer';
import DetailsBlock from '../../components/tables/DetailsBlock';
import { localizations } from '../../localization/localization';
import { RegisteredCompanyDataModel } from '../models/CompanyModels';
import { DetailsValueBlock } from '../../components/tables/DetailsValueBlock';
import { RegisteredPersonModel } from '../models/CompanyModels';
import { AddressModel, CompanyContactModel, PhoneNumberModel, EmailModel, PersonModel } from '../../common/models/CommonModels';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { renderAddressDetails, renderEmailDetails, renderPhoneDetails, renderContactPersonDetails, renderEmployee, renderDescriptionDetails, renderIndustryTypeDetails } from '../../components/tables/DetailsHelpers';
import * as SettingsStore from '../../account/store/settingsStore';
import DeleteUserConfirmation from '../../account/forms/DeleteUserConfirmation';
import { ApplicationState } from '../../store';
import { connect } from 'react-redux'
import * as CompaniesStore from '../store/companiesStore';
import DeleteCompanyForm from '../../account/forms/DeleteCompanyForm';

interface CompanyProps { 
    id: string;
    name: string;
    address: AddressModel;
    contacts: CompanyContactModel<PhoneNumberModel, EmailModel>;
    contactPerson: PersonModel;
    website: string;
    employees?: RegisteredPersonModel[];
    settings: SettingsStore.SettingsState;
    partnerApiKey: string|null
} 

type RegisteredCompanyInformationProps = RegisteredCompanyDataModel & CompanyProps & typeof SettingsStore.actionsCreators & typeof CompaniesStore.actionCreators;

interface RegisteredCompanyInformationState {
    isDeletingUser: boolean;
    userToDelete?: RegisteredPersonModel;
    isDeletingCompany: boolean;
    companyIdToDelete?: string;
}

class RegisteredCompanyInformation extends React.Component<RegisteredCompanyInformationProps, RegisteredCompanyInformationState> {

    constructor(props: RegisteredCompanyInformationProps) {
        super(props);

        this.state = {
            isDeletingUser: false,
            userToDelete: undefined,
            isDeletingCompany: false,
            companyIdToDelete: undefined
        }
           
        this.handleDeleteUser = this.handleDeleteUser.bind(this);
        this.startUserDelete = this.startUserDelete.bind(this);
        this.cancelUserDelete = this.cancelUserDelete.bind(this);
        this.handleConfirmUserDelete = this.handleConfirmUserDelete.bind(this);

        this.handleDeleteCompany = this.handleDeleteCompany.bind(this);
        this.startCompanyDelete = this.startCompanyDelete.bind(this);
        this.cancelDeleteCompany = this.cancelDeleteCompany.bind(this);
        this.handleConfirmCompanyDelete = this.handleConfirmCompanyDelete.bind(this);
        this.createPartnerApiKey = this.createPartnerApiKey.bind(this);
    }

public render() {
    const buttons = <Button variant="outlined" color="secondary" onClick={() => this.startCompanyDelete(this.props.id)}>{localizations.actions.delete}</Button>
    return <div><Grid>
    <DetailsContainer>
        <DetailsBlock title={localizations.admin.registeredCompanyInformationHeader} rightItems={buttons}>
            <DetailsValueBlock title={localizations.common.companyName}>
                <Typography>{this.props.name}</Typography>
            </DetailsValueBlock>
            {renderAddressDetails(this.props.address)}
            {this.props.contacts && this.props.contacts.phoneContacts ? this.props.contacts.phoneContacts.map((item, index) => <React.Fragment key={index}>
                {renderPhoneDetails(item, index + 1) }
                    </React.Fragment>) : <div><br/></div> }
            {this.props.contacts && this.props.contacts.emailContacts? this.props.contacts.emailContacts.map((item, index) => <React.Fragment key={index}>
                {renderEmailDetails(item, index + 1)}
                    </React.Fragment>) : <div><br/></div> }
            {renderContactPersonDetails(this.props.contactPerson)}
            <DetailsValueBlock title={localizations.common.website}>
                <Typography>{this.props.website}</Typography>
            </DetailsValueBlock>
            <DetailsValueBlock title={localizations.admin.partnerApiKey}>
                {this.props.partnerApiKey === null ?
                <Button variant="outlined" color="secondary" onClick={() => this.createPartnerApiKey(this.props.id)}>{localizations.actions.create}</Button> :
                <Typography>{this.props.partnerApiKey}</Typography>}
            </DetailsValueBlock>
            {renderIndustryTypeDetails(this.props.industryType)}
            {renderDescriptionDetails(this.props.description)}
        </DetailsBlock>
        <DetailsBlock title={localizations.admin.companyEmployees}>
            {
                this.props.employees ? this.props.employees.map((item, index) => <React.Fragment key={index}>{renderEmployee(item, this.startUserDelete)}</React.Fragment>)
                    : <div><br /><Typography color="error">{localizations.register.noAddedCoordinators}</Typography></div>
            }
        </DetailsBlock>
    </DetailsContainer>
    </Grid>
    {this.state.isDeletingUser && this.state.userToDelete ? <DeleteUserConfirmation isOpen={this.state.isDeletingUser} user={this.state.userToDelete} onSubmit={this.handleConfirmUserDelete} onCancel={this.cancelUserDelete} /> : null}
    {this.state.isDeletingCompany && this.state.companyIdToDelete ? <DeleteCompanyForm companyId={this.state.companyIdToDelete} isOpen={this.state.isDeletingCompany} onSubmit={this.handleConfirmCompanyDelete} onCancel={this.cancelDeleteCompany} /> : null}
    </div>
    }

    private startUserDelete(person: RegisteredPersonModel) {
        this.setState({
            isDeletingUser: true,
            userToDelete: person
        });
    }

    private cancelUserDelete() {
        this.setState({
            isDeletingUser: false,
            userToDelete: undefined
        });
    }

    private handleConfirmUserDelete() {
        if (this.state.userToDelete) {
            this.handleDeleteUser(this.state.userToDelete);
        }
    }

    private handleDeleteUser(person: RegisteredPersonModel) {
        this.props.adminDeleteUser(person.id);
        this.cancelUserDelete();
    }

    private startCompanyDelete(companyId: string) {
        this.setState({
            isDeletingCompany: true,
            companyIdToDelete: companyId
        })
    }

    private handleDeleteCompany(companyId: string) {
        this.props.deleteCompany(companyId);
        this.cancelDeleteCompany();
    }

    private cancelDeleteCompany() {
        this.setState({
            isDeletingCompany: false,
            companyIdToDelete: undefined
        })
    }

    private handleConfirmCompanyDelete() {
        if (this.state.companyIdToDelete) {
            this.handleDeleteCompany(this.state.companyIdToDelete);
        }
    }

    private createPartnerApiKey(companyId: string){
        this.props.createPartnerApiKey(companyId);
    }
}

const mapStateToProps = (state: ApplicationState) => {
    const { settings } = state;

    return { settings };
}

export default connect(mapStateToProps, { ...SettingsStore.actionsCreators, ...CompaniesStore.actionCreators } )(RegisteredCompanyInformation);


// WEBPACK FOOTER //
// ./src/admin/companies/RegisteredCompanyInformation.tsx